import { useDiaryByIdQuery } from "@/features/diaries/api/diaryQueries";
import { MessageHistorySheet } from "@/features/knock/components/MessageHistorySheet";
import MarkReadButtons from "../../read-unread/components/MarkReadButtons";
import ActionDropdown from "./ActionDropdown";
import DownloadButton from "./DownloadButton";
// import DoppioPrintButton from "./DoppioPrintButton";
import MoreDropdown from "./MoreDropdown";

interface Props {
	diaryId: string;
}

const InterfaceButtons = ({ diaryId }: Props) => {
	const { data: diary } = useDiaryByIdQuery(diaryId);
	if (!diary) return null;
	return (
		<div className="flex justify-between items-center mt-1">
			<div className="flex items-center gap-1">
				{/* <DownloadButton
					patientId={diary?.patient_id}
					diaryId={diary?.diary_id}
				/> */}
				<MarkReadButtons diary={diary} />
				<MessageHistorySheet patientId={diary.patient_id} />
			</div>
			<div className="flex flex-row gap-2">
				<MoreDropdown diary={diary} />
				{diary.allowed_actions && (
					<ActionDropdown actionOptions={diary.allowed_actions} />
				)}
			</div>
		</div>
	);
};

export default InterfaceButtons;
